export const CTA = [
  {
    label: 'RevenueM',
    value: 'revenueM'
  },
  {
    label: 'RevenueW',
    value: 'revenueW'
  },
  {
    label: 'RetailSales',
    value: 'retailSales'
  },
  {
    label: 'BusinessLine',
    value: 'businessLine'
  },
  {
    label: 'Visits1',
    value: 'visits1'
  },
  {
    label: 'Visits2',
    value: 'visits2'
  }
];
